const exceptionAccountNumbers = [408, 423, 426, 455, 457, 61212];
const regexpExceptionAccountNumber = new RegExp(
    `^(${exceptionAccountNumbers.join('|')})`,
    'gm',
);
/**
 * @description Method check value is account number.
 * @param {string} value - Checked value.
 * @returns {boolean} Result of check.
 */
export const isAccountNumber = (value: string): boolean => {
    const clearValue = value.trim().replace(/\s/g, '');
    const firstNumberOfAccount = [0, 1, 7, 8, 9];
    const regexpFirstNumberOfAccount = new RegExp(
        `^(${firstNumberOfAccount.join('|')})`,
        'gm',
    );
    return Boolean(
        clearValue.match(regexpExceptionAccountNumber) ||
            clearValue.match(regexpFirstNumberOfAccount),
    );
};
